import { Image } from "./Image";

export enum RemoteNotificationTrigger {
  INVALID_SUBSCRIPTION = "invalidSubscription",
  MANUAL = "manual",
  COUPON_EXPIRATION = "couponExpiration",
  IDLE_USER_WARN = "idleUserWarn",
  IDLE_USER_ERROR = "idleUserStop",
  PLAYTIME_OVER_WARN = "playtimeOverWarning",
  PLAYTIME_OVER = "playtimeOver",
  UBISOFT_CONNECT = "ubisoftConnect",
  PLAN_SUBSCRIBED = "planSubscribed",
  GAMEPAD_COMPANION_CONNECTED = "gamepadcompanionConnected",
  STREAM_STARTED = "streamStarted",
  STREAM_ENDED = "streamEnded",
  STREAM_ENDED_DUPLICATE_SESSION = "streamAskForEnded",
}
export enum RemoteNotificationFormat {
  WEBVIEW = "webview",
  DIALOG = "dialog",
  BANNER = "banner",
}

export interface RemoteNotification {
  id: string;
  description: string;
  linkText: string;
  link?: string;
  isNew: boolean;
  trigger: RemoteNotificationTrigger;
  createdAt: string;
  format: RemoteNotificationFormat;
  title: string;
  image?: Image;
}

export class RemoteNotificationImpl implements RemoteNotification {
  public id!: string;
  public description!: string;
  public linkText!: string;
  public link?: string | undefined;
  public isNew: boolean;
  public trigger!: RemoteNotificationTrigger;
  public format!: RemoteNotificationFormat;
  public createdAt!: string;
  public title!: string;
  public image?: Image;

  constructor(fields: RemoteNotification) {
    Object.assign(this, fields);
    this.isNew = false;
  }
}
